import type { Tabs as TabsProps } from '@ps/web-martech-cms-types';
import classNames from 'clsx';
import React from 'react';

import { CMSReference } from '@swf/cms';

import styles from './CMSTabs.scss';

const CMSTabs: React.FC<TabsProps> = ({ tabs }) => {
  const [activeTab, setActiveTab] = React.useState<number>(0);

  return (
    <div>
      <div className={styles.panelTabs}>
        {tabs.map(({ tab }, index) => (
          <button
            key={index}
            onClick={() => setActiveTab(index)}
            className={classNames(styles.tab, { [styles.selectedTab]: index === activeTab })}
          >
            {tab.title}
          </button>
        ))}
      </div>
      <div className={styles.panel}>
        {tabs.map(
          ({ tab }, index) => activeTab === index && <CMSReference key={index} {...tab.body[0]} />
        )}
      </div>
    </div>
  );
};
export default CMSTabs;
